export const common = {
  // Navigation
  'nav.features': 'Fitur',
  'nav.howItWorks': 'Cara kerjanya',
  'nav.pricing': 'Harga',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Tentang Kami',
  'nav.getStarted': 'Mulai',

  // About Us Section
  'aboutUs.badge': "Tentang kami",
  'aboutUs.title': "Mengapa IdeaVerdict ada",
  'aboutUs.line1': "Siapa pun bisa punya ide.",
  'aboutUs.line2': "Sedikit yang mau mengakui idenya tidak kuat.",
  'aboutUs.paragraph1':
    "Sebagian besar ide gagal bukan karena foundernya kurang berani. Mereka gagal karena tidak ada yang mengatakan kebenarannya cukup awal. IdeaVerdict menutup celah itu — kami memberikan bacaan brutal yang tidak akan diberikan teman-temanmu.",
  'aboutUs.belief1a': "Kami tidak berdagang hype.",
  'aboutUs.belief1b': "Kami berdagang sinyal pasar.",
  'aboutUs.belief2a': "Kami tidak menjual motivasi.",
  'aboutUs.belief2b': "Kami menjual bacaan jelas atas permintaan, persaingan, dan kelayakan.",
  'aboutUs.mission1': "Tugas kami bukan membuat idemu terlihat bagus.",
  'aboutUs.mission2': "Tugas kami memberitahumu apakah ide itu memang bagus.",
  'aboutUs.analysis':
    "IdeaVerdict menilai ide berdasarkan hal-hal yang menentukan — struktur pasar, permintaan nyata, persaingan, modal yang dibutuhkan, waktu sampai pendapatan, skalabilitas. Tanpa emosi. Tanpa optimisme. Hanya analisis.",
  'aboutUs.failure1': "Sebagian besar bisnis gagal.",
  'aboutUs.failure2': "Bukan karena orang di baliknya tidak kompeten —",
  'aboutUs.failure3': "tapi karena tidak ada yang menentang cukup keras, cukup awal.",
  'aboutUs.clarity': "Kami ada untuk menentang.",
  'aboutUs.value1': "Langsung.",
  'aboutUs.value2': "Jujur.",
  'aboutUs.value3': "Cepat.",
  'aboutUs.confirm': "Jika idemu bersubstansi, kami dukung.",
  'aboutUs.deny': "Jika tidak, kami katakan ke wajahmu.",
  'aboutUs.noApplause': "Tanpa tepuk tangan.",
  'aboutUs.noSugarcoating': "Tanpa pemanis.",
  'aboutUs.noTheater': "Tanpa teater.",
  'aboutUs.noHype': "Hanya putusan.",
  // Hero Section
  'hero.badge': 'Putusan AI dalam kurang dari 60 detik',
  'hero.title1': 'Jangan bangun',
  'hero.title2': 'sebelum memeriksa.',
  'hero.subtitle': 'IdeaVerdict menguji idemu seperti VC yang skeptis.',
  'hero.subtitleLine2': 'Putusan jujur dalam hitungan detik — tanpa hype, tanpa basa-basi.',
  'hero.cta': 'Dapatkan putusanku',
  'hero.ctaSecondary': 'Lihat cara kerjanya',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Kredit per permintaan',
  'hero.stat2Value': 'Mulai 7',
  'hero.stat2Label': 'Dimensi penilaian',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Jujur & Pribadi',

  // Features Section
  'features.title1': 'Dibuat untuk',
  'features.title2': 'pendiri yang',
  'features.title3': 'menginginkan kebenaran',
  'features.bullet1.title': 'Vonis jujur dalam hitungan detik',
  'features.bullet1.description':
    'Kuat, Campur, atau Lemah — dengan alasan di balik setiap penilaian. Tidak ada tepuk tangan, tidak ada pemanis, tidak ada drama.',
  'features.bullet2.title': 'Dinilai berdasarkan yang penting',
  'features.bullet2.description':
    'Ide Anda dinilai berdasarkan permintaan nyata, persaingan, kebutuhan modal, waktu mencapai pendapatan, dan skalabilitas — bukan firasat.',
  'features.bullet3.title': 'Dari vonis ke produk',
  'features.bullet3.description':
    'Mode Builder mengubah ide yang lolos menjadi briefing developer: alur pengguna, fitur inti, catatan teknis.',

  // How It Works
  'howItWorks.title': 'Cara kerjanya',
  'howItWorks.subtitle': 'Empat langkah menuju kejelasan tentang ceruk bisnis Anda.',
  'howItWorks.step1Title': 'Pilih paket',
  'howItWorks.step1Desc': 'Starter, Pro atau Builder – tergantung kedalaman ulasan Anda.',
  'howItWorks.step2Title': 'Tanya AI',
  'howItWorks.step2Desc': 'Ajukan pertanyaan Anda tentang ceruk. Setiap permintaan membutuhkan 30 kredit.',
  'howItWorks.step3Title': 'Dapatkan vonis jujur',
  'howItWorks.step3Desc': 'AI menilai: Baik, Sedang atau Buruk. Tanpa pemanis.',
  'howItWorks.step4Title': 'Buat keputusan',
  'howItWorks.step4Desc': 'Sekarang Anda tahu apakah itu layak untuk dilanjutkan.',

  // Pricing
  'pricing.title': 'Harga',
  'pricing.subtitle': 'Pilih paket yang sesuai dengan kedalaman ulasan Anda.',
  'pricing.monthly': 'Bulanan',
  'pricing.yearly': 'Tahunan',
  'pricing.yearlyDiscount': 'Langganan tahunan:',
  'pricing.yearlyDiscountValue': '-20% diskon',
  'pricing.perMonth': 'per bulan',
  'pricing.selectPlan': 'Pilih Paket',
  'pricing.mostPopular': 'Paling Populer',
  'pricing.footer':
    'Semua harga dalam CHF. Kredit hanya dipotong untuk respons AI yang berhasil.',

  
  // Pricing Features
  'pricing.feature1': 'Obrolan Gratis (tanpa formulir)',
  'pricing.feature2': 'Logika pasar & penilaian jujur',
  'pricing.feature3': 'Riwayat obrolan persisten',
  'pricing.feature4': 'Beberapa sesi obrolan paralel',
  'pricing.feature5': 'Sepenuhnya multibahasa',
  'pricing.feature6': 'Penggunaan berbasis kredit',
  'pricing.feature7': 'Reset bulanan',
  'pricing.feature8': 'Analisis pasar',
  'pricing.feature9': 'Ringkasan',
  'pricing.feature10': 'Kekuatan',
  'pricing.feature11': 'Kelemahan',
  'pricing.feature12': 'Peluang',
  'pricing.feature13': 'Risiko',
  'pricing.feature14': 'Rekomendasi',
  'pricing.feature15': 'Unduh PDF',
  'pricing.feature16': 'Tanpa pengarahan pengembang',
  'pricing.feature17': 'Mode Builder: Pengarahan pengembang',
  'pricing.feature18': 'Ringkasan terstruktur',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Akses ke chatbot ceruk AI',
  'pricing.starter.credits': '2.500 Kredit per bulan',
  'pricing.starter.feature1': 'Hasilkan ide ceruk',
  'pricing.starter.feature2': 'Perbaiki ceruk',
  'pricing.starter.feature3': 'Pemeriksaan realitas pasar',
  'pricing.starter.feature4': 'Penilaian persaingan',
  'pricing.starter.feature5': 'Penilaian waktu',
  'pricing.starter.feature6': 'Vonis jujur',
  'pricing.starter.feature7': 'Sesi pribadi',
  'pricing.starter.feature8': 'Riwayat & ekspor',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Akses ke chatbot ceruk AI',
  'pricing.pro.credits': '5.000 Kredit per bulan',
  'pricing.pro.feature1': 'Semua fitur Starter',
  'pricing.pro.feature2': 'Lebih banyak kredit untuk ulasan intensif',
  'pricing.pro.feature3': 'Saran perbaikan',
  'pricing.pro.feature4': 'Ceruk alternatif',
  'pricing.pro.feature5': 'Analisis pasar terperinci',
  'pricing.pro.feature6': 'Dukungan prioritas',
  'pricing.pro.feature7': 'Filter lanjutan',
  'pricing.pro.feature8': 'Favorit sesi',

  // Builder Plan
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Semua fitur + mode Builder",
  'pricing.builder.credits': "10.000 Kredit per bulan",
  'pricing.builder.feature1': 'Semua fitur Pro',
  'pricing.builder.feature2': 'Permintaan AI tidak terbatas',
  'pricing.builder.feature3': 'Mode Builder: Pengarahan pengembang',
  'pricing.builder.feature4': 'Gambaran proyek terstruktur',
  'pricing.builder.feature5': 'Alur pengguna & fitur inti',
  'pricing.builder.feature6': 'Catatan teknis',
  'pricing.builder.feature7': 'Tentukan non-tujuan',
  'pricing.builder.feature8': 'Batas penggunaan wajar',
  'pricing.builder.limitNote': 'Batas penggunaan wajar',
  'pricing.monthlyReset': 'Reset bulanan',

  // Modal
  'pricing.modal.selected': 'dipilih',
  'pricing.modal.comingSoon':
    'Pendaftaran dan pemrosesan pembayaran akan segera tersedia.',
  'pricing.modal.patience':
    'Kami sedang bekerja untuk memberikan Anda pengalaman yang aman dan lancar. Harap bersabar.',
  'pricing.modal.understood': 'Dimengerti',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Dijawab dengan jujur & kritis.',
  'faq.q1': "IdeaVerdict sebenarnya melakukan apa?",
  'faq.a1': "Ia menilai ide bisnismu pada hal-hal yang menentukan hasil — permintaan nyata, persaingan, modal yang dibutuhkan, waktu sampai pasar, dan skalabilitas.\nJika ide bertahan, kami tunjukkan cara mempertajamnya.\nJika tidak, itu juga kami katakan.",
  'faq.q2': "Apakah kalian juga menghasilkan ide?",
  'faq.a2': "Ya — tapi bukan saran asal-asalan dari topi sulap.\nIde datang dari celah pasar nyata, bukan apa pun yang sedang tren minggu ini.",
  'faq.q3': "Apakah kalian memperbaiki model bisnis yang ada?",
  'faq.a3': "Ya, jika ada yang bisa diperbaiki.\nKami tidak memoles ide rusak — kami memperkuat yang sudah punya dasar.",
  'faq.q4': "Apa bedanya kalian dengan tool AI lain?",
  'faq.a4': "Sebagian besar tool AI bilang idemu hebat.\nKami katakan apakah idemu memang hebat.\nBedanya: realisme, bukan antusiasme.",
  'faq.q5': "Apakah ini menjamin kesuksesan?",
  'faq.a5': "Tidak.\nKami bantu menghindari taruhan buruk — risiko tidak hilang, tapi kamu masuk dengan mata terbuka.",
  'faq.q6': "Untuk siapa IdeaVerdict?",
  'faq.a6': "Founder sebelum peluncuran.\nBuilder sebelum proyek sampingan akhir pekan.\nOperator sebelum taruhan berikutnya.\nInvestor sebelum tanda tangan.\n\nUntuk siapa pun yang mau kejelasan sebelum komitmen.",
  'faq.q7': "Bagaimana jika aku cuma mau validasi?",
  'faq.a7': "Kalau begitu IdeaVerdict adalah tool yang salah.\nKami memberikan bacaan jujur, bukan penenangan.",
  'faq.q8': "Seberapa jujur sebenarnya analisisnya?",
  'faq.a8': "Sejujur yang data izinkan.\nKami tidak melunakkan putusan lemah demi perasaan.",
  'faq.q9': "Apakah ini menggantikan riset pasar sungguhan?",
  'faq.a9': "Tidak.\nIni pengecekan strategis cepat sebelum kamu berinvestasi — bukan studi pasar 50 halaman.",
  'faq.q10': "Kenapa begitu langsung?",
  'faq.a10': "Karena membangun hal yang salah menghabiskan berbulan-bulan.\nPutusan jujur menghabiskan menit.\n\nKami memilih menit.",
  // Footer
  'footer.description':
    'IdeaVerdict tidak ada untuk membuatmu merasa baik. Ia ada untuk membantumu memutuskan dengan benar.',
  'footer.product': 'Produk',
  'footer.aiAssistant': 'Asisten AI',
  'footer.howItWorks': 'Cara kerjanya',
  'footer.pricing': 'Harga',
  'footer.faq': 'FAQ',
  'footer.legal': 'Hukum',
  'footer.privacy': 'Privasi',
  'footer.terms': 'Ketentuan',
  'footer.imprint': 'Keterangan',
  'footer.support': 'Dukungan',
  'footer.contact': 'Kontak',
  'footer.documentation': 'Dokumentasi',
  'footer.copyright': '© 2026 IdeaVerdict. Semua hak dilindungi.',

  // AI Assistant
  'aiAssistant.title': 'Asisten Ceruk AI',
  'aiAssistant.subtitle': 'Tanya tentang ceruk',
  'aiAssistant.welcomeMessage':
    'Hai! Jelaskan ide Anda atau tanyakan tentang ceruk. Saya akan memberikan evaluasi yang jelas dan jujur.',
  'aiAssistant.demoResponse':
    'Ini adalah demo. Untuk mendapatkan evaluasi AI nyata, silakan daftar dan pilih paket.',
  'aiAssistant.placeholder': 'Jelaskan ide Anda...',

  // Header & Sidebar
  'dashboard.header.title': 'Dasbor',
  'dashboard.header.aiAssistant': 'Asisten AI Anda',
  'header.logout': 'Keluar',
  'dashboard.sidebar.overview': 'Ikhtisar',
  'dashboard.sidebar.aiChat': 'Asisten AI',
  'dashboard.sidebar.newAnalysis': 'Asisten AI',
  'dashboard.sidebar.history': 'Riwayat',
  'dashboard.sidebar.credits': 'Kredit',
  'dashboard.sidebar.settings': 'Pengaturan',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Selamat datang kembali, {{name}}',
  'dashboard.overview.subtitle':
    'Berikut adalah ikhtisar cepat aktivitas Anda',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Sisa kredit',
  'dashboard.stats.totalAnalyses': 'Total analisis',
  'dashboard.stats.goodRatings': 'Penilaian positif',
  'dashboard.stats.nextReset': 'Reset berikutnya dalam',
  'dashboard.stats.days': 'hari',

  // Quick Actions
  'dashboard.quickActions.title': 'Tindakan cepat',
  'dashboard.quickActions.checkNewIdea': 'Periksa ide',
  'dashboard.quickActions.checkNewIdeaDesc':
    'Analisis ide bisnis yang ada',
  'dashboard.quickActions.generateIdea': 'Hasilkan ide',
  'dashboard.quickActions.generateIdeaDesc':
    'Temukan ceruk menguntungkan baru',
  'dashboard.quickActions.builderBriefing': 'Pengarah pembangun',
  'dashboard.quickActions.builderBriefingDesc':
    'Ubah ide menjadi pengarahan siap-pengembang',
  'dashboard.quickActions.premiumOnly': 'Hanya Builder',

  // Chat Header
  'chat.title': 'Asisten Ceruk AI',
  'chat.subtitle':
    'Ajukan pertanyaan tentang ceruk. Saya mengevaluasi secara kritis dan jujur.',
  'chat.creditsLabel': 'Kredit',

  // Chat Welcome
  'chat.welcomeTitle': 'Selamat datang di Asisten Ceruk AI',
  'chat.welcomeDesc':
    'Jelaskan ide Anda atau tanyakan tentang ceruk. Saya akan mengevaluasinya dengan jujur: Baik, Sedang atau Buruk.',
  'chat.aiWelcome':
    'Hai! Jelaskan ide Anda atau tanyakan tentang ceruk. Saya akan memberikan evaluasi yang jelas dan jujur.',

  // Chat Suggestions
  'chat.suggestion1': 'Saya ingin membuat alat SaaS untuk freelancer mengelola faktur. Apakah ini ceruk yang bagus?',
  'chat.suggestion2': 'Carikan bisnis online dengan persaingan rendah yang bisa saya mulai dengan $500 tanpa coding.',
  'chat.suggestion3': 'Evaluasi ini: aplikasi perencanaan makan berbasis AI untuk orang tua sibuk dengan batasan diet.',
  'chat.suggestion4': 'Saya ingin menjual template digital di Etsy untuk pemilik usaha kecil. Analisis ceruk ini dengan jujur.',

  // Chat Actions
  'chat.newConversation': 'Percakapan baru',
  'chat.today': 'Hari ini',
  'chat.yesterday': 'Kemarin',
  'chat.thisWeek': 'Minggu ini',
  'chat.thisMonth': 'Bulan ini',
  'chat.older': 'Lebih lama',
  'chat.messages': 'pesan',
  'chat.renameConversation': 'Ganti nama',
  'chat.deleteConversation': 'Hapus',
  'chat.cancel': 'Batal',
  'chat.rename': 'Ganti nama',
  'chat.delete': 'Hapus',
  'chat.favorite': 'Tambahkan favorit',
  'chat.unfavorite': 'Hapus favorit',
  'chat.searchSessions': 'Cari percakapan...',
  'chat.noResults': 'Tidak ada hasil ditemukan',
  'chat.noSessions': 'Belum ada percakapan',
  'chat.enterNewName': 'Masukkan nama baru...',
  'chat.deleteConfirmMessage':
    'Apakah Anda yakin ingin menghapus percakapan ini? Tindakan ini tidak dapat dibatalkan.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Ketik pertanyaan Anda… (biaya 30 kredit)',
  'chat.send': 'Kirim',
  'chat.voice': 'Bicara',
  'chat.listeningPlaceholder': 'Saya mendengarkan... Bicaralah sekarang.',
  'chat.stopListening': 'Berhenti mendengarkan',
  'chat.recording': 'Merekam...',
  'chat.speechNotSupported': 'Browser Anda tidak mendukung pengenalan suara.',
  'chat.microphonePermissionDenied': 'Akses mikrofon ditolak. Harap izinkan akses di pengaturan browser.',
  'chat.errorNotEnoughCredits':
    'Kredit tidak mencukupi. Silakan tingkatkan paket Anda atau tunggu reset berikutnya.',
  'chat.errorAiFailed': 'Respons AI gagal. Tidak ada kredit yang dipotong.',
  'chat.errorRateLimit': 'Terlalu banyak permintaan. Harap tunggu sebentar.',

  // Ratings
  'rating.good': 'Baik',
  'rating.medium': 'Sedang',
  'rating.bad': 'Buruk',

  // Auth Page
  'auth.branding.headline1': 'Tidak semua ide itu bagus.',
  'auth.branding.headline2': 'Kami mengatakannya dengan jujur.',
  'auth.branding.subtitle':
    'AI keputusan untuk ceruk bisnis. Jelas. Kritis. Tanpa pemanis.',
  'auth.benefits.privacy.title': '100% Pribadi',
  'auth.benefits.privacy.desc':
    'Ide Anda tetap sepenuhnya pribadi dan aman.',
  'auth.benefits.honest.title': 'AI Jujur',
  'auth.benefits.honest.desc':
    'Tanpa pemanis – hanya umpan balik yang jelas dan kritis.',
  'auth.benefits.fast.title': 'Hasil Cepat',
  'auth.benefits.fast.desc': 'Dapatkan kejelasan tentang ceruk Anda dalam hitungan menit.',
  'auth.trust.users': 'Pengguna Aktif',
  'auth.trust.ideas': 'Ide Dianalisis',
  'auth.trust.rating': 'Peringkat Pengguna',
  'auth.login.title': 'Masuk',
  'auth.login.headline': 'Selamat datang kembali',
  'auth.login.subtitle': 'Masuk untuk melanjutkan perjalanan Anda.',
  'auth.login.forgotPassword': 'Lupa kata sandi?',
  'auth.login.submit': 'Masuk',
  'auth.login.noAccount': 'Belum punya akun?',
  'auth.login.signUp': 'Daftar',
  'auth.register.title': 'Daftar',
  'auth.register.headline': 'Buat akun Anda',
  'auth.register.subtitle':
    'Mulai analisis ide bisnis Anda hari ini.',
  'auth.register.submit': 'Buat Akun',
  'auth.register.hasAccount': 'Sudah punya akun?',
  'auth.register.signIn': 'Masuk',
  'auth.fields.name': 'Nama Lengkap',
  'auth.fields.email': 'Alamat Email',
  'auth.fields.password': 'Kata Sandi',
  'auth.fields.confirmPassword': 'Konfirmasi Kata Sandi',
  'auth.fields.selectPlan': 'Pilih paket Anda',
  'auth.fields.testCode': 'Masuk dan uji coba gratis',
  'auth.placeholders.name': 'Masukkan nama Anda',
  'auth.placeholders.email': 'Masukkan email Anda',
  'auth.placeholders.password': 'Masukkan kata sandi Anda',
  'auth.placeholders.confirmPassword': 'Konfirmasi kata sandi Anda',
  'auth.placeholders.testCode': 'Masukkan kode uji coba',
  'auth.terms.accept': 'Saya menerima',
  'auth.terms.terms': 'Syarat & Ketentuan',
  'auth.privacy.accept': 'Saya menerima',
  'auth.privacy.policy': 'Kebijakan Privasi',
  'auth.errors.nameRequired': 'Nama wajib diisi',
  'auth.errors.emailRequired': 'Email wajib diisi',
  'auth.errors.emailInvalid': 'Masukkan email yang valid',
  'auth.errors.passwordRequired': 'Kata sandi wajib diisi',
  'auth.errors.passwordLength': 'Kata sandi minimal 8 karakter',
  'auth.errors.passwordMismatch': 'Kata sandi tidak cocok',
  'auth.errors.invalidCode': 'Kode tidak valid atau kedaluwarsa',
  'auth.errors.registrationCodeOnly': 'Kode ini hanya untuk pendaftaran',
  'auth.errors.verificationFailed': 'Kesalahan verifikasi kode. Silakan coba lagi.',
  'auth.loading': 'Harap tunggu...',
  'auth.or': 'atau lanjutkan dengan',
  'auth.social.google': 'Lanjutkan dengan Google',
  'auth.social.apple': 'Lanjutkan dengan Apple',
  'auth.actions.verify': 'Verifikasi',
  'auth.testCode.activated': 'Kode uji coba diaktifkan!',
  'auth.testCode.days': 'hari',
  'auth.testCode.months': 'bulan',
  'auth.testCode.freeAccess': 'akses gratis',
  'auth.testCode.credits': 'kredit',

  // Email Verification
  'auth.verification.title': 'Verifikasi Email',
  'auth.verification.headline': 'Periksa kotak masuk Anda',
  'auth.verification.subtitle': 'Kami mengirim kode verifikasi ke:',
  'auth.verification.codeLabel': 'Kode Verifikasi',
  'auth.verification.codePlaceholder': 'Masukkan kode 6 digit',
  'auth.verification.submit': 'Verifikasi Email',
  'auth.verification.resend': 'Kirim ulang kode',
  'auth.verification.resendIn': 'Kirim ulang dalam',
  'auth.verification.seconds': 'detik',
  'auth.verification.success': 'Email berhasil diverifikasi!',
  'auth.verification.error': 'Kode tidak valid. Silakan coba lagi.',
  'auth.verification.expired': 'Kode kedaluwarsa. Harap minta yang baru.',
  'auth.verification.sent': 'Kode baru dikirim!',
  'auth.verification.checkSpam':
    "Tidak menerimanya? Periksa folder spam Anda.",

  // Forgot Password
  'auth.forgot.title': 'Lupa Kata Sandi',
  'auth.forgot.headline': 'Atur ulang kata sandi Anda',
  'auth.forgot.subtitle':
    "Masukkan alamat email Anda dan kami akan mengirimkan tautan reset.",
  'auth.forgot.submit': 'Kirim Tautan Reset',
  'auth.forgot.backToLogin': 'Kembali ke masuk',
  'auth.forgot.success': 'Email terkirim!',
  'auth.forgot.successMessage':
    "Kami telah mengirimkan email dengan instruksi untuk mengatur ulang kata sandi Anda.",
  'auth.forgot.checkInbox': 'Periksa kotak masuk Anda',

  // Reset Password
  'auth.reset.title': 'Kata Sandi Baru',
  'auth.reset.headline': 'Atur kata sandi baru',
  'auth.reset.subtitle': 'Masukkan kata sandi baru Anda.',
  'auth.reset.newPassword': 'Kata Sandi Baru',
  'auth.reset.confirmNewPassword': 'Konfirmasi Kata Sandi Baru',
  'auth.reset.submit': 'Ubah Kata Sandi',
  'auth.reset.success': 'Kata sandi berhasil diubah!',
  'auth.reset.successMessage':
    'Anda sekarang dapat masuk dengan kata sandi baru Anda.',
  'auth.reset.loginNow': 'Masuk sekarang',

  // Legal Pages
  'legal.backToAuth': 'Kembali ke masuk',
  'legal.allRightsReserved': 'Hak cipta dilindungi.',

  // Terms Page
  'legal.terms.title': 'Syarat dan Ketentuan',
  'legal.terms.lastUpdated': 'Terakhir diperbarui',
  'legal.terms.section1.title': '1. Lingkup',
  'legal.terms.section1.content':
    'Syarat dan Ketentuan ini berlaku untuk semua kontrak antara NicheFinder (selanjutnya "Penyedia") dan pengguna (selanjutnya "Pelanggan") mengenai penggunaan platform analisis ceruk bertenaga AI.',
  'legal.terms.section2.title': '2. Deskripsi Layanan',
  'legal.terms.section2.content':
    'Penyedia menawarkan platform berbasis AI yang menganalisis dan mengevaluasi ide dan ceruk bisnis. Layanan meliputi:',
  'legal.terms.section2.item1': 'Analisis ide bisnis bertenaga AI',
  'legal.terms.section2.item2': 'Evaluasi potensi pasar dan persaingan',
  'legal.terms.section2.item3': 'Generasi saran ceruk',
  'legal.terms.section2.item4': 'Pembuatan pengarahan pengembang (paket Builder)',
  'legal.terms.section3.title': '3. Kesimpulan Kontrak dan Pendaftaran',
  'legal.terms.section3.content':
    'Kontrak disimpulkan melalui pendaftaran di platform dan pemilihan paket. Pelanggan mengonfirmasi:',
  'legal.terms.section3.item1': 'Sudah dewasa dan sepenuhnya cakap hukum',
  'legal.terms.section3.item2': 'Memberikan informasi yang benar selama pendaftaran',
  'legal.terms.section3.item3': 'Penyimpanan aman kredensial akses',
  'legal.terms.section4.title': '4. Kredit dan Penagihan',
  'legal.terms.section4.content':
    'Penggunaan fitur AI didasarkan pada sistem kredit. Setiap permintaan AI membutuhkan 30 kredit. Kredit hanya dipotong setelah respons berhasil. Kredit yang tidak terpakai kedaluwarsa pada akhir periode penagihan dan tidak dapat dikembalikan.',
  'legal.terms.section5.title': '5. Penafian',
  'legal.terms.section5.content':
    'Evaluasi AI hanya berfungsi sebagai alat bantu pengambilan keputusan dan tidak menjamin kesuksesan bisnis. Penyedia tidak bertanggung jawab atas keputusan yang dibuat berdasarkan analisis AI. Tanggung jawab atas kesengajaan dan kelalaian berat tetap tidak terpengaruh.',
  'legal.terms.section6.title': '6. Perlindungan Data dan Kerahasiaan',
  'legal.terms.section6.content':
    'Semua ide bisnis yang diajukan diperlakukan secara rahasia dan tidak dibagikan kepada pihak ketiga. Pemrosesan data pribadi dilakukan sesuai dengan Kebijakan Privasi kami dan undang-undang perlindungan data yang berlaku.',
  'legal.terms.section7.title': '7. Penghentian',
  'legal.terms.section7.content':
    'Pelanggan dapat membatalkan langganan mereka kapan saja pada akhir periode penagihan berjalan. Jika terjadi pelanggaran terhadap Ketentuan ini, Penyedia berhak memblokir akses ke platform.',
  'legal.terms.section8.title': '8. Ketentuan Final',
  'legal.terms.section8.content':
    'Hukum Swiss berlaku. Tempat yurisdiksi adalah Zurich, Swiss. Jika ketentuan individual dari Ketentuan ini tidak berlaku, validitas ketentuan lainnya tidak terpengaruh.',
  'legal.terms.contact.title': 'Pertanyaan tentang Ketentuan?',
  'legal.terms.contact.content':
    'Jika Anda memiliki pertanyaan tentang Syarat dan Ketentuan ini, silakan hubungi kami di:',

  // Privacy Page
  'legal.privacy.title': 'Kebijakan Privasi',
  'legal.privacy.section1.title': '1. Pengontrol Data',
  'legal.privacy.section1.content':
    'Pengontrol data untuk situs web ini adalah NicheFinder, Zurich, Swiss. Kami sangat memperhatikan perlindungan data pribadi Anda dan memperlakukan data pribadi Anda secara rahasia dan sesuai dengan peraturan perlindungan data yang berlaku.',
  'legal.privacy.section2.title': '2. Data yang Dikumpulkan',
  'legal.privacy.section2.content':
    'Kami mengumpulkan dan memproses data pribadi berikut:',
  'legal.privacy.section2.item1':
    'Data pendaftaran: Nama, alamat email, kata sandi (dienkripsi)',
  'legal.privacy.section2.item2':
    'Data penggunaan: Alamat IP, jenis browser, waktu akses',
  'legal.privacy.section2.item3':
    'Ide bisnis dan permintaan ceruk (disimpan secara anonim)',
  'legal.privacy.section2.item4':
    'Informasi pembayaran (melalui penyedia pihak ketiga yang aman)',
  'legal.privacy.section3.title': '3. Tujuan Pemrosesan Data',
  'legal.privacy.section3.content':
    'Data Anda digunakan untuk tujuan berikut:',
  'legal.privacy.section3.item1':
    'Penyediaan dan peningkatan layanan AI kami',
  'legal.privacy.section3.item2':
    'Manajemen akun dan otentikasi',
  'legal.privacy.section3.item3':
    'Penagihan dan pemrosesan pembayaran',
  'legal.privacy.section4.title': '4. Keamanan Data',
  'legal.privacy.section4.content':
    'Kami menerapkan langkah-langkah keamanan teknis dan organisasi untuk melindungi data Anda dari manipulasi, kehilangan, penghancuran, atau akses tidak sah. Semua transfer data dienkripsi melalui SSL/TLS.',
  'legal.privacy.section5.title': '5. Kerahasiaan Ide Bisnis Anda',
  'legal.privacy.section5.content':
    'Ide bisnis dan permintaan ceruk yang Anda kirimkan diperlakukan dengan sangat rahasia. Mereka tidak dibagikan kepada pihak ketiga, tidak digunakan untuk tujuan pelatihan, dan dapat dihapus sepenuhnya atas permintaan. Ide Anda milik Anda.',
  'legal.privacy.section6.title': '6. Hak Anda',
  'legal.privacy.section6.content':
    'Anda memiliki hak berikut terkait data pribadi Anda:',
  'legal.privacy.section6.item1': 'Hak untuk mengakses data yang tersimpan',
  'legal.privacy.section6.item2': 'Hak untuk memperbaiki data yang tidak akurat',
  'legal.privacy.section6.item3': 'Hak untuk menghapus data Anda',
  'legal.privacy.section6.item4': 'Hak atas portabilitas data',
  'legal.privacy.section7.title': '7. Cookie',
  'legal.privacy.section7.content':
    'Situs web kami hanya menggunakan cookie yang diperlukan secara teknis untuk otentikasi dan manajemen sesi. Kami tidak menggunakan cookie pelacakan atau alat analitik pihak ketiga tanpa persetujuan eksplisit Anda.',
  'legal.privacy.section8.title': '8. Perubahan Kebijakan Privasi Ini',
  'legal.privacy.section8.content':
    'Kami berhak untuk menyesuaikan kebijakan privasi ini untuk mematuhi perubahan persyaratan hukum atau ketika perubahan pada layanan terjadi. Versi terbaru selalu dapat ditemukan di halaman ini.',
  'legal.privacy.contact.title': 'Pertanyaan tentang Privasi?',
  'legal.privacy.contact.content':
    'Jika Anda memiliki pertanyaan tentang pemrosesan data pribadi Anda, silakan hubungi kami di:',

  'auth.passwordStrength.label': 'Kekuatan kata sandi',
  'auth.passwordStrength.weak': 'Lemah',
  'auth.passwordStrength.medium': 'Sedang',
  'auth.passwordStrength.strong': 'Kuat',
  'auth.passwordStrength.veryStrong': 'Sangat kuat',
  'auth.passwordStrength.minLength': 'Min. 8 karakter',
  'auth.passwordStrength.uppercase': 'Huruf besar',
  'auth.passwordStrength.number': 'Angka',
  'auth.passwordStrength.special': 'Karakter khusus',

  trial: {
    subtitle: 'Uji Coba Gratis',
    upgrade: 'Tingkatkan Sekarang',
    creditsRemaining: 'sisa kredit',
    inputHint: 'Versi uji coba - Riwayat percakapan tidak tersedia',
    banner: {
      title: 'Uji Coba 7 Hari Aktif',
      remaining: '{{days}} hari tersisa',
      credits: 'kredit tersedia',
      upgradeNow: 'Tingkatkan Sekarang',
    },
    welcome: {
      title: 'Selamat Datang di Uji Coba Gratis!',
      desc: 'Uji asisten AI kami gratis selama 7 hari dengan 100 kredit. Ajukan pertanyaan dan temukan kemungkinannya!',
    },
    info: {
      title: 'Batasan Uji Coba',
      credits: '100 kredit selama 7 hari',
      noHistory: 'Tidak ada riwayat percakapan',
      noSettings: 'Fitur terbatas',
      upgrade: 'Tingkatkan untuk fitur lengkap',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': 'Pengaturan',
  'settings.subtitle': 'Kelola akun dan preferensi Anda',
  'settings.backToOverview': 'Kembali ke ikhtisar',
  'settings.subscriptionLink': 'Langganan & Penagihan',
  'settings.saved': 'Perubahan berhasil disimpan',
  'settings.changesSaved': 'Perubahan disimpan',
  'settings.saveChanges': 'Simpan perubahan',
  'settings.dataExported': 'Data berhasil diekspor',

  // Tabs
  'settings.tabs.profile': 'Profil',
  'settings.tabs.preferences': 'Preferensi',
  'settings.tabs.notifications': 'Notifikasi',
  'settings.tabs.account': 'Akun & Paket',

  // Profile
  'settings.profile.changePhoto': 'Ubah foto',
  'settings.profile.photoHint': 'JPG, PNG atau GIF (maks. 2MB)',
  'settings.profile.uploading': 'Mengunggah...',
  'settings.profile.photoUpdated': 'Foto profil diperbarui!',
  'settings.profile.name': 'Nama',
  'settings.profile.email': 'Email',
  'settings.profile.phone': 'Telepon',
  'settings.profile.changePassword': 'Ubah kata sandi',
  'settings.profile.currentPassword': 'Kata sandi saat ini',
  'settings.profile.newPassword': 'Kata sandi baru',
  'settings.profile.confirmPassword': 'Konfirmasi kata sandi',

  // Preferences
  'settings.preferences.language': 'Bahasa',
  'settings.preferences.chooseLanguage': 'Pilih bahasa',
  'settings.preferences.timezone': 'Zona waktu',
  'settings.preferences.currency': 'Mata uang',

  // Notifications
  'settings.notifications.emailTitle': 'Notifikasi Email',
  'settings.notifications.email.analysis': 'Analisis selesai',
  'settings.notifications.email.analysisDesc': 'Terima email saat analisis Anda siap',
  'settings.notifications.email.credits': 'Pembaruan kredit',
  'settings.notifications.email.creditsDesc': 'Notifikasi tentang kredit dan reset',
  'settings.notifications.email.billing': 'Faktur & Pembayaran',
  'settings.notifications.email.billingDesc': 'Notifikasi tentang faktur dan perubahan paket',
  'settings.notifications.email.newsletter': 'Buletin',
  'settings.notifications.email.newsletterDesc': 'Tips, pembaruan dan fitur baru',
  'settings.notifications.pushTitle': 'Notifikasi Push',
  'settings.notifications.push.analysis': 'Analisis selesai',
  'settings.notifications.push.analysisDesc': 'Notifikasi browser saat analisis siap',
  'settings.notifications.push.credits': 'Peringatan kredit',
  'settings.notifications.push.creditsDesc': 'Peringatan saat saldo kredit rendah',

  // Account
  'settings.account.currentSubscription': 'Langganan Saat Ini',
  'settings.account.plan': 'Paket',
  'settings.account.price': 'Harga',
  'settings.account.nextBilling': 'Penagihan berikutnya',
  'settings.account.manageSubscription': 'Kelola langganan & pembayaran',
  'settings.account.dataPrivacy': 'Data & Privasi',
  'settings.account.exportData': 'Ekspor data',
  'settings.account.deleteAccount': 'Hapus akun',

  // Delete Modal
  'settings.deleteModal.title': 'Hapus akun?',
  'settings.deleteModal.subtitle': 'Semua data akan dihapus secara permanen.',
  'settings.deleteModal.warning1': 'Semua analisis dan data akan dihapus',
  'settings.deleteModal.warning2': 'Langganan aktif akan segera dibatalkan',
  'settings.deleteModal.warning3': 'Tidak ada pengembalian dana',
  'settings.deleteModal.confirmLabel': 'Ketik "{{word}}" untuk konfirmasi *',
  'settings.deleteModal.cancel': 'Batal',
  'settings.deleteModal.confirm': 'Hapus akun',

  // ─── Subscription & Billing ─────────────────────────────────
  'sub.backToOverview': 'Kembali ke ikhtisar',
  'sub.settings': 'Pengaturan',
  'sub.title': 'Langganan & Penagihan',
  'sub.subtitle': 'Kelola langganan, metode pembayaran dan faktur Anda',
  'sub.tab.overview': 'Ikhtisar',
  'sub.tab.payment': 'Metode Pembayaran',
  'sub.tab.billing': 'Alamat Penagihan',
  'sub.tab.history': 'Riwayat Pembayaran',
  'sub.memberSince': 'Anggota sejak',
  'sub.perMonth': 'per bulan',
  'sub.baseCHF': '(CHF {{amount}} dasar)',
  'sub.nextBilling': 'Penagihan berikutnya',
  'sub.creditsUsed': 'Kredit terpakai',
  'sub.paymentMethod': 'Metode pembayaran',
  'sub.creditUsage': 'Penggunaan kredit',
  'sub.changePlan': 'Ubah paket',
  'sub.reactivate': 'Aktifkan kembali',
  'sub.cancelSub': 'Batalkan langganan',
  'sub.manageCards': 'Kelola kartu',
  'sub.downloadInvoices': 'Unduh faktur',
  'sub.invoicesAvailable': '{{count}} faktur tersedia sebagai PDF',
  'sub.accountSettings': 'Pengaturan Akun',
  'sub.profileNotifications': 'Profil, notifikasi & lainnya',
  // Prices in EUR info
  'sub.eurInfo': 'Harga ditampilkan dalam',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Nilai tukar:',
  'sub.currentRate': 'Nilai tukar saat ini',
  // Payment Methods
  'sub.savedCards': 'Kartu Tersimpan',
  'sub.newCard': 'Kartu Baru',
  'sub.default': 'Default',
  'sub.setDefault': 'Atur sebagai default',
  'sub.validUntil': 'Berlaku hingga',
  'sub.noCards': 'Tidak ada kartu tersimpan',
  'sub.addFirstCard': 'Tambahkan kartu pertama',
  'sub.securePayments': 'Pembayaran Aman',
  'sub.securePaymentsDesc': 'Semua data pembayaran dikirimkan terenkripsi dan disimpan dengan aman bersama penyedia pembayaran kami. Kami tidak menyimpan nomor kartu lengkap.',
  // Billing Address
  'sub.billingAddress': 'Alamat Penagihan',
  'sub.edit': 'Edit',
  'sub.name': 'Nama',
  'sub.streetAddress': 'Jalan & Nomor',
  'sub.zip': 'Kode Pos',
  'sub.city': 'Kota',
  'sub.country': 'Negara',
  'sub.address': 'Alamat',
  'sub.save': 'Simpan',
  'sub.cancel': 'Batal',
  'sub.country.switzerland': 'Swiss',
  'sub.country.germany': 'Jerman',
  'sub.country.austria': 'Austria',
  'sub.country.netherlands': 'Belanda',
  'sub.country.belgium': 'Belgia',
  // Payment History
  'sub.paymentHistory': 'Riwayat Pembayaran',
  'sub.allInvoicesPDF': 'Unduh semua faktur sebagai PDF dengan logo',
  'sub.downloadAll': 'Unduh semua',
  'sub.eurInvoiceNote': 'Faktur selalu diterbitkan dalam CHF. Jumlah EUR yang ditampilkan hanya untuk referensi.',
  'sub.date': 'Tanggal',
  'sub.description': 'Deskripsi',
  'sub.net': 'Bersih',
  'sub.vat': 'PPN',
  'sub.total': 'Total',
  'sub.status': 'Status',
  'sub.pdf': 'PDF',
  'sub.invoices': 'faktur',
  'sub.totalAmount': 'Jumlah total',
  // Change Plan Modal
  'sub.changePlanTitle': 'Ubah Paket',
  'sub.current': 'Saat ini',
  'sub.month': '/bulan',
  'sub.showLess': 'Tampilkan lebih sedikit',
  'sub.showMore': '+{{count}} lagi',
  'sub.switchPlan': 'Ganti paket',
  'sub.eurPriceNote': 'Harga ditampilkan dalam EUR ({{note}}). Penagihan dalam CHF.',
  // Cancel Modal
  'sub.cancelTitle': 'Batalkan langganan?',
  'sub.cancelIrreversible': 'Tindakan ini tidak dapat dibatalkan.',
  'sub.cancelWarning1': 'Semua sisa kredit akan kedaluwarsa',
  'sub.cancelWarning2': 'Turun ke Paket Gratis',
  'sub.cancelWarning3': 'Kehilangan semua fitur premium',
  'sub.pauseInstead': 'Alternatif: Jeda langganan?',
  'sub.pauseDesc': 'Jeda langganan Anda dan simpan data Anda.',
  'sub.preferPause': 'Lebih suka jeda',
  'sub.cancelReason': 'Alasan pembatalan',
  'sub.selectReason': 'Silakan pilih...',
  'sub.reason.tooExpensive': 'Terlalu mahal',
  'sub.reason.notUsing': 'Tidak cukup menggunakannya',
  'sub.reason.missingFeatures': 'Fitur yang hilang',
  'sub.reason.foundAlternative': 'Menemukan alternatif',
  'sub.reason.other': 'Lainnya',
  'sub.confirmType': 'Konfirmasi: Ketik "CANCEL" *',
  'sub.cancelNow': 'Batalkan sekarang',
  // Add Card Modal
  'sub.addCardTitle': 'Tambahkan Kartu Baru',
  'sub.cardHolder': 'Pemegang Kartu *',
  'sub.cardNumber': 'Nomor Kartu *',
  'sub.expiryDate': 'Tanggal Kedaluwarsa *',
  'sub.addCard': 'Tambah kartu',
  // Change Card Modal
  'sub.choosePayment': 'Pilih metode pembayaran',
  'sub.active': 'Aktif',
  'sub.close': 'Tutup',
  // Toast messages
  'sub.toast.cancelled': 'Langganan Anda telah dibatalkan pada akhir periode penagihan.',
  'sub.toast.reactivated': 'Langganan Anda berhasil diaktifkan kembali!',
  'sub.toast.planChanged': 'Paket berhasil diubah menjadi {{plan}}!',
  'sub.toast.defaultChanged': 'Metode pembayaran default diubah.',
  'sub.toast.cannotDeleteDefault': 'Kartu default tidak dapat dihapus.',
  'sub.toast.cardRemoved': 'Kartu telah dihapus.',
  'sub.toast.fillAll': 'Harap isi semua bidang.',
  'sub.toast.cardAdded': 'Kartu baru berhasil ditambahkan!',
  'sub.toast.billingSaved': 'Alamat penagihan disimpan.',
  'sub.toast.invoiceDownloaded': 'Faktur {{id}} diunduh!',
  'sub.toast.pdfError': 'Kesalahan membuat PDF.',
  // Chat interface
  'sub.notEnoughCredits': 'Kredit tidak cukup',
  'sub.needCredits': 'Anda membutuhkan setidaknya {{count}} kredit per pertanyaan.',
  'sub.creditsLow': 'Kredit hampir habis',
  'sub.questionsLeft': '{{count}} pertanyaan dimungkinkan.',
  'sub.plan': 'Paket',
  'sub.base': 'dasar',
  'sub.unlimited': 'Tidak terbatas',
  'sub.status.active': 'Aktif',
  'sub.status.cancelled': 'Dibatalkan',
  'sub.status.paused': 'Dijeda',
  'sub.invoice': 'FAKTUR',
  'sub.from': 'DARI',
  'sub.to': 'KEPADA',
  'sub.vatId': 'NPWP',
  'sub.tel': 'Telp',
  'sub.invoiceDate': 'Tanggal faktur',
  'sub.invoiceNumber': 'Nomor faktur',
  'sub.paymentStatus': 'Status pembayaran',
  'sub.creditCard': 'Kartu kredit',
  'sub.quantity': 'QTY',
  'sub.price': 'HARGA',
  'sub.amount': 'JUMLAH',
  'sub.subtotal': 'Subtotal',
  'sub.bank': 'Bank',
  'sub.card': 'Kartu',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'John Doe',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': 'Dasbor Admin',
  'admin.subtitle': 'Pusat Kontrol',
  'admin.superAdmin': 'Super Admin',
  'admin.logout': 'Keluar',
  'admin.tabs.users': 'Manajemen Pengguna',
  'admin.tabs.downgrades': 'Penurunan',
  'admin.tabs.tips': 'Tip of the Day',
  'admin.tabs.coupons': 'Kode Kupon',
  'admin.tabs.website': 'Editor Situs Web',
  'admin.tabs.ai': 'Pengaturan AI',
  'admin.tabs.transactions': 'Log Transaksi',
  'admin.tabs.stats': 'Statistik',
  'admin.users.searchPlaceholder': 'Cari pengguna (email atau nama)...',
  'admin.users.manageSubscription': 'Kelola langganan',
  'admin.users.grantFree': 'Berikan akun gratis',
  'admin.users.blockUser': 'Blokir pengguna',
  'admin.users.cancellationPlaceholder': 'Mengapa langganan dibatalkan?',
  'admin.users.selectPlan': 'Pilih paket',
  'admin.users.subChanged': 'Langganan {{name}} diubah menjadi {{plan}}',
  'admin.users.noReasonGiven': 'Tidak ada alasan diberikan',
  'admin.users.subCancelled': 'Langganan {{name}} dibatalkan (berlaku hingga {{date}})',
  'admin.users.paused': 'Dijeda',
  'admin.users.subPaused': 'Langganan {{name}} telah dijeda',
  'admin.users.subReactivated': 'Langganan {{name}} telah diaktifkan kembali',
  'admin.users.freeAccount': 'Akun Gratis',
  'admin.users.blocked': 'Diblokir',
  'admin.users.cancelledExpiring': 'Dibatalkan (akan kedaluwarsa)',
  'admin.users.cancelledOn': 'Dibatalkan:',
  'admin.users.endsOn': 'Berakhir:',
  'admin.users.daysRemaining': 'hari tersisa',
  'admin.users.expired': '(Kedaluwarsa)',
  'admin.users.total': 'Total:',
  'admin.users.usersLabel': 'pengguna',
  'admin.users.free': 'gratis',
  'admin.users.block': 'Blokir',
  'admin.users.unblock': 'Buka blokir',
  'admin.users.unblockUser': 'Buka blokir pengguna',
  'admin.users.selectAction': 'Pilih tindakan',
  'admin.users.cancelSub': 'Batalkan langganan',
  'admin.users.cancelSubDesc': 'Pembatalan di akhir bulan',
  'admin.users.pauseSub': 'Jeda langganan',
  'admin.users.pauseSubDesc': 'Jeda sementara',
  'admin.users.changePlan': 'Ubah paket',
  'admin.users.changePlanDesc': 'Beralih ke paket lain',
  'admin.users.reactivateSub': 'Aktifkan kembali langganan',
  'admin.users.reactivateDesc': 'Batalkan pembatalan',
  'admin.users.alreadyCancelled': 'Langganan sudah dibatalkan',
  'admin.users.planLabel': 'Paket',
  'admin.users.cancellationReasonOpt': 'Alasan pembatalan (opsional)',
  'admin.users.cancelInfo1': 'Langganan akan berakhir pada',
  'admin.users.cancelInfo2': '(akhir bulan). Sampai saat itu pengguna memiliki akses penuh. Tidak ada pengembalian dana.',
  'admin.users.newPlan': 'Paket baru',
  'admin.users.warning': 'Peringatan',
  'admin.users.blockDesc': 'Pengguna akan segera keluar dan tidak dapat masuk lagi. Semua sesi aktif akan dihentikan.',
  'admin.users.confirmUnblock': 'Konfirmasi buka blokir',
  'admin.users.unblockDesc': 'Pengguna dapat masuk lagi dan menggunakan semua fitur.',
  'admin.users.afterBlock': 'Setelah pemblokiran:',
  'admin.users.afterUnblock': 'Setelah membuka blokir:',
  'admin.users.noAccountAccess': 'Tidak ada akses akun',
  'admin.users.noNewAnalyses': 'Tidak ada analisis baru yang dimungkinkan',
  'admin.users.creditsStored': 'Kredit dan riwayat tetap tersimpan',
  'admin.users.accessRestored': 'Akses akun dipulihkan',
  'admin.users.allFeaturesAvail': 'Semua fitur tersedia lagi',
  'admin.users.creditsPreserved': 'Kredit dan riwayat dipertahankan',
  'admin.users.downgrade': 'Turunkan Paket',
  'admin.users.grantFreeBtn': 'Berikan gratis',
  'admin.users.durationMonths': 'Durasi (bulan)',
  'admin.users.months': 'bulan',
  'admin.users.freePlan': 'gratis',
  'admin.users.freeSummary': 'menerima',
  'admin.users.withCredits': 'dengan',
  'admin.users.credits': 'Kredit',
  'admin.users.subInfo': 'Informasi Langganan',
  'admin.users.currentPlan': 'Paket Saat Ini',
  'admin.users.joined': 'Bergabung',
  'admin.users.totalSpent': 'Total Dibelanjakan',
  'admin.users.paymentMethod': 'Metode Pembayaran',
  'admin.users.validThrough': 'Berlaku hingga',
  'admin.users.billingAddress': 'Alamat Penagihan',
  'admin.users.transactionHistory': 'Riwayat Transaksi',
  'admin.users.cancellationDate': 'Tanggal pembatalan',
  'admin.users.validUntil': 'Berlaku hingga (akhir bulan)',
  'admin.users.cancellationReason': 'Alasan pembatalan',
  'admin.users.noReason': 'Tidak ada alasan diberikan',
  'admin.users.timeRemaining': 'Waktu tersisa',
  'admin.users.daysUntilDeactivation': 'hari hingga penonaktifan',
  'admin.table.user': 'Pengguna',
  'admin.table.plan': 'Paket',
  'admin.table.subStatus': 'Status Langganan',
  'admin.table.cancellation': 'Pembatalan',
  'admin.table.payment': 'Metode Pembayaran',
  'admin.table.spending': 'Pengeluaran',
  'admin.table.actions': 'Tindakan',
  'admin.actions.viewDetails': 'Lihat detail',
  'admin.actions.manageSubscription': 'Kelola langganan',
  'admin.actions.grantFree': 'Berikan akses gratis',
  'admin.actions.block': 'Blokir pengguna',
  'admin.actions.unblock': 'Buka blokir pengguna',
  'admin.actions.cancel': 'Batal',
  'admin.actions.save': 'Simpan',
  'admin.actions.delete': 'Hapus',
  'admin.actions.confirm': 'Konfirmasi',
  'admin.actions.done': 'Selesai',
  'admin.actions.edit': 'Edit',
  'admin.actions.close': 'Tutup',
  'admin.table.status': 'Status',
  'admin.filter.all': 'Semua',
  'admin.subscription.active': 'Aktif',
  'admin.subscription.cancelled': 'Dibatalkan',
  'admin.subscription.paused': 'Dijeda',
  'admin.subscription.unknown': 'Tidak diketahui',
  'admin.status.active': 'Aktif',
  'admin.status.inactive': 'Tidak Aktif',
  'admin.status.pending': 'Tertunda',
  'admin.status.approved': 'Disetujui',
  'admin.status.rejected': 'Ditolak',
  'admin.coupons.title': 'Manajemen Kupon',
  'admin.coupons.subtitle': 'Buat dan kelola kode kupon',
  'admin.coupons.newCoupon': 'Kupon Baru',
  'admin.coupons.registrationCoupons': 'Kupon Pendaftaran',
  'admin.coupons.trialCoupons': 'Kupon Akses Uji Coba',
  'admin.coupons.type': 'Tipe',
  'admin.coupons.plan': 'Paket',
  'admin.coupons.value': 'Nilai',
  'admin.coupons.usage': 'Penggunaan',
  'admin.coupons.validUntil': 'Berlaku Hingga',
  'admin.coupons.created': 'Dibuat',
  'admin.coupons.actions': 'Tindakan',
  'admin.coupons.copyCode': 'Salin kode',
  'admin.coupons.allPlans': 'Semua Paket',
  'admin.coupons.discount': 'Diskon',
  'admin.coupons.days': 'hari',
  'admin.coupons.months': 'bulan',
  'admin.coupons.free': 'gratis',
  'admin.coupons.unlimited': 'Tidak Terbatas',
  'admin.coupons.createRegistration': 'Buat Kupon Pendaftaran',
  'admin.coupons.createTrial': 'Buat Kupon Akses Uji Coba',
  'admin.coupons.couponCode': 'Kode Kupon',
  'admin.coupons.codePlaceholder': 'misal NF-7X3K9M',
  'admin.coupons.generateCode': 'Hasilkan kode baru',
  'admin.coupons.alertFillRequired': 'Harap isi semua bidang yang diperlukan',
  'admin.coupons.alertSelectExpiry': 'Harap pilih tanggal kedaluwarsa atau aktifkan "Validitas tidak terbatas"',
  'admin.coupons.alertCreateError': 'Kesalahan membuat kupon',
  'admin.coupons.confirmDelete': 'Apakah Anda yakin ingin menghapus kupon ini?',
  'admin.coupons.discountPercent': 'Diskon (%)',
  'admin.coupons.bonusCredits': 'Kredit Bonus',
  'admin.coupons.freeDuration': 'Durasi Gratis',
  'admin.coupons.maxUses': 'Penggunaan Maks',
  'admin.coupons.expiryDate': 'Tanggal Kedaluwarsa',
  'admin.coupons.unlimitedValidity': 'Validitas tidak terbatas',
  'admin.coupons.unlimitedUses': 'Penggunaan tidak terbatas',
  'admin.coupons.trialCredits': 'Kredit Uji Coba',
  'admin.coupons.trialDuration': 'Durasi Uji Coba',
  'admin.coupons.typePlaceholder': 'misal Early Bird, Partner, Influencer',
  'admin.coupons.duration': 'Durasi',
  'admin.stats.totalUsers': 'Total Pengguna',
  'admin.stats.monthlyRevenue': 'Pendapatan Bulanan',
  'admin.stats.activeSubscriptions': 'Langganan Aktif',
  'admin.stats.average': 'Rata-rata',
  'admin.stats.revenuePerUser': 'Pendapatan per Pengguna',
  'admin.stats.grossRevenue': 'Pendapatan Kotor',
  'admin.stats.net': 'BERSIH',
  'admin.stats.netRevenue': 'Pendapatan Bersih',
  'admin.stats.churnRate': 'Tingkat Churn',
  'admin.stats.planDistribution': 'Distribusi Paket',
  'admin.stats.users': 'pengguna',
  'admin.stats.revenueByPlan': 'Pendapatan berdasarkan Paket',
  'admin.stats.recentActivity': 'Aktivitas Terbaru',
  'admin.stats.activity1': 'Thomas Weber meningkatkan ke Builder',
  'admin.stats.activity2': 'Pengguna baru terdaftar',
  'admin.stats.activity3': 'Anna Schmidt meningkatkan ke Pro',
  'admin.stats.hoursAgo2': '2 jam lalu',
  'admin.stats.hoursAgo5': '5 jam lalu',
  'admin.stats.dayAgo1': '1 hari lalu',
  'admin.stats.couponStats': 'Statistik Kupon',
  'admin.stats.totalRedemptions': 'Total Penukaran',
  'admin.stats.activeCoupons': 'Kupon Aktif',
  'admin.stats.registrationRedemptions': 'Penukaran Pendaftaran',
  'admin.stats.trialRedemptions': 'Penukaran Uji Coba',
  'admin.stats.couponDistribution': 'Distribusi Kupon',
  'admin.stats.registrationCoupons': 'Kupon Pendaftaran',
  'admin.stats.trialCoupons': 'Kupon Uji Coba',
  'admin.stats.expiredInactive': 'Kedaluwarsa/Tidak Aktif',
  'admin.stats.topCoupons': 'Kupon Teratas berdasarkan Penukaran',
  'admin.stats.redemptions': 'penukaran',
  'admin.stats.noCouponsRedeemed': 'Belum ada kupon yang ditukarkan',
  'admin.downgrade.pending': 'tertunda',
  'admin.downgrade.refunds': 'Pengembalian Dana',
  'admin.downgrade.sectionRequests': 'Permintaan',
  'admin.downgrade.sectionStats': 'Statistik',
  'admin.downgrade.sectionRules': 'Aturan',
  'admin.downgrade.pendingRequests': 'Permintaan Tertunda',
  'admin.downgrade.approvedRequests': 'Permintaan Disetujui',
  'admin.downgrade.rejectedRequests': 'Permintaan Ditolak',
  'admin.downgrade.activeRules': 'Aturan Aktif',
  'admin.downgrade.autoRules': 'Aturan Penurunan Otomatis',
  'admin.downgrade.autoRulesDesc': 'Buat aturan yang secara otomatis memicu penurunan berdasarkan perilaku penggunaan',
  'admin.downgrade.newRule': 'Aturan Baru',
  'admin.downgrade.totalRules': 'Total Aturan',
  'admin.downgrade.triggeredActions': 'Tindakan yang Dipicu',
  'admin.downgrade.conditionsAnd': 'Kondisi (dihubungkan dengan AND)',
  'admin.downgrade.action': 'Tindakan',
  'admin.downgrade.successTitle': 'Penurunan berhasil!',
  'admin.downgrade.successDesc': 'Pengguna telah berhasil diturunkan dan pengembalian dana telah diproses.',
  'admin.downgrade.closing': 'Menutup...',
  'admin.downgrade.title': 'Turunkan Pengguna',
  'admin.downgrade.currentPlan': 'Paket Saat Ini',
  'admin.downgrade.spending': 'Pengeluaran',
  'admin.downgrade.availablePlans': 'Paket Tersedia untuk Penurunan',
  'admin.downgrade.perMonth': 'per bulan',
  'admin.downgrade.refundCalc': 'Perhitungan Pengembalian Dana',
  'admin.downgrade.currentPlanLabel': 'Paket Saat Ini',
  'admin.downgrade.newPlan': 'Paket Baru',
  'admin.downgrade.remainingDays': 'Sisa Hari',
  'admin.downgrade.daysOf': '15 dari 30 hari',
  'admin.downgrade.proRataRefund': 'Pengembalian Dana Pro-rata',
  'admin.downgrade.importantNote': 'Catatan Penting',
  'admin.downgrade.warningDesc': 'Penurunan akan dieksekusi segera. Pengguna akan kehilangan akses ke fitur premium dan kelebihan kredit akan dihapus.',
  'admin.downgrade.processing': 'Memproses...',
  'admin.downgrade.execute': 'Eksekusi Penurunan',
  'admin.downgrade.notification': 'Notifikasi',
  'admin.downgrade.noNotification': 'Tidak Ada Notifikasi',
  'admin.downgrade.daysPeriod': 'hari masa tenggang',
  'admin.downgrade.created': 'Dibuat:',
  'admin.downgrade.triggered': 'dipicu',
  'admin.downgrade.noRules': 'Belum ada aturan yang dibuat',
  'admin.downgrade.createFirstRule': 'Buat aturan pertama',
  'admin.downgrade.editRule': 'Edit Aturan',
  'admin.downgrade.createRule': 'Buat Aturan Baru',
  'admin.downgrade.ruleName': 'Nama aturan',
  'admin.downgrade.description': 'Deskripsi',
  'admin.downgrade.allConditions': 'Kondisi (semua harus dipenuhi)',
  'admin.downgrade.addCondition': 'Tambah kondisi',
  'admin.downgrade.type': 'Tipe',
  'admin.downgrade.value': 'Nilai',
  'admin.downgrade.fromPlan': 'Dari paket',
  'admin.downgrade.toPlan': 'Ke paket',
  'admin.condition.inactivity': 'Tidak Aktif',
  'admin.condition.creditUsage': 'Penggunaan Kredit',
  'admin.condition.loginFrequency': 'Frekuensi Masuk',
  'admin.condition.featureUsage': 'Penggunaan Fitur',
  'admin.condition.supportTickets': 'Tiket Dukungan',
  'admin.operator.lessThan': 'kurang dari',
  'admin.operator.greaterThan': 'lebih dari',
  'admin.operator.equals': 'tepat',
  'admin.operator.between': 'antara',
  'admin.unit.days': 'hari',
  'admin.unit.perMonth': 'per bulan',
  'admin.unit.count': 'jumlah',
  'admin.transactions.all': 'Semua Transaksi',
  'admin.transactions.allCards': 'Semua Kartu',
  'admin.transactions.notFound': 'Tidak ada transaksi ditemukan',
  'admin.transactions.totalLabel': 'Total',
  'admin.transactions.transactions': 'transaksi',
  'admin.tips.title': 'Tip of the Day',
  'admin.tips.subtitle': 'Buat dan kelola tip yang ditampilkan kepada semua pengguna',
  'admin.tips.active': 'Aktif',
  'admin.tips.currentlyShown': 'Tip ini saat ini ditampilkan kepada semua pengguna',
  'admin.tips.createNew': 'Buat Tip Baru',
  'admin.tips.generating': 'Menghasilkan...',
  'admin.tips.generateAI': 'Hasilkan Tip AI',
  'admin.tips.titleLabel': 'Judul',
  'admin.tips.titlePlaceholder': 'misal Tip of the Day',
  'admin.tips.category': 'Kategori',
  'admin.tips.categoryTip': 'Tip',
  'admin.tips.categoryFeature': 'Fitur Baru',
  'admin.tips.categoryProductivity': 'Produktivitas',
  'admin.tips.categoryUpdate': 'Pembaruan',
  'admin.tips.content': 'Konten',
  'admin.tips.contentPlaceholder': 'Tulis tip Anda untuk pengguna di sini...',
  'admin.tips.addTip': 'Tambah Tip',
  'admin.tips.allTips': 'Semua Tip',
  'admin.tips.noTips': 'Belum ada tip yang dibuat',
  'admin.tips.noTipsHint': 'Klik "Hasilkan Tip AI" untuk memulai',
  'admin.noData': 'Tidak ada data tersedia',
  'admin.range.7d': '7 hari',
  'admin.range.30d': '30 hari',
  'admin.range.90d': '90 hari',
  'admin.range.1y': '1 tahun',
  'admin.actions.saveSettings': 'Simpan pengaturan',
  'admin.actions.create': 'Buat',
  'admin.downgrade.sectionReports': 'Laporan',
  'admin.downgrade.settings': 'Pengaturan Penurunan',
  'admin.downgrade.autoApprove': 'Persetujuan Otomatis',
  'admin.downgrade.autoApproveDesc': 'Setujui permintaan penurunan secara otomatis',
  'admin.downgrade.refundPolicy': 'Kebijakan Pengembalian Dana',
  'admin.downgrade.prorata': 'Pengembalian dana pro-rata',
  'admin.downgrade.prorataDesc': 'Pengembalian dana proporsional berdasarkan sisa hari',
  'admin.downgrade.fullRefund': 'Pengembalian dana penuh',
  'admin.downgrade.fullRefundDesc': 'Pengembalian dana lengkap dari selisih harga',
  'admin.downgrade.noRefund': 'Tidak ada pengembalian dana',
  'admin.downgrade.noRefundDesc': 'Penurunan tanpa pengembalian dana',
  'admin.downgrade.daysRemaining15': '(dengan 15 hari tersisa)',
  'admin.downgrade.requestsTitle': 'Permintaan Penurunan',
  'admin.downgrade.approvalRate': 'Tingkat persetujuan',
  'admin.downgrade.mostCommonTransition': 'Transisi paling umum',
  'admin.downgrade.mostCommonReason': 'Alasan paling umum',
  'admin.downgrade.avgProcessingTime': 'Rata-rata waktu pemrosesan',
  'admin.downgrade.avgTimeDesc': 'Waktu rata-rata hingga keputusan',
  'admin.downgrade.totalRefunds': 'Total Pengembalian Dana',
  'admin.downgrade.pendingRefunds': 'Pengembalian Dana Tertunda',
  'admin.downgrade.summary': 'Ringkasan',
  'admin.downgrade.total': 'Total',
  'admin.downgrade.csvDesc': 'Untuk Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'Unduh sebagai CSV',
  'admin.downgrade.jsonDesc': 'Untuk pengembang, API',
  'admin.downgrade.downloadJSON': 'Unduh sebagai JSON',
  'admin.downgrade.exportInfo': 'Ekspor berisi',
  'admin.downgrade.entries': 'entri dari periode yang dipilih',
  'admin.downgrade.topReasons': 'Alasan penurunan paling umum',
  'admin.downgrade.refundHistory': 'Riwayat Pengembalian Dana',
  'admin.downgrade.noRefunds': 'Belum ada pengembalian dana',
  'admin.downgrade.statistics': 'Statistik Penurunan',
  'admin.downgrade.requests': 'Permintaan',
  'admin.downgrade.monthlyTrend': 'Tren Bulanan',
  'admin.downgrade.planTransitions': 'Transisi Paket',
  'admin.downgrade.trend': 'Tren (vs. bulan sebelumnya)',
  'admin.downgrade.trendDesc': 'Lebih sedikit penurunan = lebih baik',
  'admin.coupons.allPlansUniversal': 'Semua Paket (Universal)',
  'admin.coupons.onlyStarter': 'Hanya Starter',
  'admin.coupons.onlyPro': 'Hanya Pro',
  'admin.coupons.onlyBuilder': 'Hanya Builder',
  'admin.coupons.allPlansHint': 'Pilih "Semua Paket" untuk kupon universal',
  'admin.coupons.discountOptional': 'Diskon % (opsional)',
  'admin.coupons.discountPlaceholder': 'misal 50 untuk diskon 50%',
  'admin.coupons.bonusCreditsOptional': 'Kredit Bonus (opsional)',
  'admin.coupons.bonusCreditsPlaceholder': 'misal 500',
  'admin.coupons.freeDurationOptional': 'Durasi Gratis (opsional)',
  'admin.coupons.durationPlaceholder': 'misal 30',
  'admin.coupons.freeDurationHint': 'misal 30 hari gratis digunakan',
  'admin.coupons.noLimit': 'Tidak ada batasan penggunaan',
  'admin.coupons.noExpiry': 'Tidak ada tanggal kedaluwarsa',
  'admin.coupons.creditsPlaceholder': 'misal 100',
  'admin.coupons.creditsHint': 'Jumlah kredit untuk akses uji coba',
  'admin.coupons.trialDurationHint': 'Berapa lama akses uji coba valid',
  'admin.coupons.autoCalculated': 'Dihitung secara otomatis dari durasi uji coba',
  'admin.websiteEditor.title': 'Editor Situs Web',
  'admin.websiteEditor.subtitle': 'Edit semua bagian dari beranda',
  'admin.websiteEditor.openPreview': 'Buka Pratinjau',
  'admin.websiteEditor.group.structure': 'Struktur Halaman',
  'admin.websiteEditor.group.design': 'Desain & Tata Letak',
  'admin.websiteEditor.group.settings': 'Pengaturan',
  'admin.websiteEditor.tab.navbar': 'Navigasi',
  'admin.websiteEditor.tab.howitworks': 'Cara Kerjanya',
  'admin.websiteEditor.tab.about': 'Tentang Kami',
  'admin.websiteEditor.tab.pricing': 'Harga',
  'admin.websiteEditor.tab.sections': 'Bagian',
  'admin.websiteEditor.tab.media': 'Media',
  'admin.websiteEditor.tab.chatwidget': 'Bicara dengan Kami',
  'admin.websiteEditor.tab.invoice': 'Faktur',
  'admin.websiteEditor.tab.legal': 'Hukum',
  'admin.websiteEditor.tab.seo': 'SEO Dasar',
  'admin.websiteEditor.tab.advancedseo': 'SEO Lanjutan',
  'admin.websiteEditor.tab.versions': 'Versi',
  'admin.hero.title': 'Edit Bagian Hero',
  'admin.hero.subtitle': 'Teks, tombol dan statistik beranda',
  'admin.hero.reset': 'Atur Ulang',
  'admin.hero.save': 'Simpan',
  'admin.hero.savedMsg': 'Data Hero disimpan!',
  'admin.hero.badge': 'Teks Lencana',
  'admin.hero.headings': 'Judul',
  'admin.hero.line1White': 'Baris 1 (putih)',
  'admin.hero.line2Gold': 'Baris 2 (emas)',
  'admin.hero.subtitleSection': 'Subjudul',
  'admin.hero.line1': 'Baris 1',
  'admin.hero.line2': 'Baris 2',
  'admin.hero.buttons': 'Tombol',
  'admin.hero.primaryBtn': 'Tombol Utama (emas)',
  'admin.hero.secondaryBtn': 'Tombol Sekunder (batas)',
  'admin.hero.stats': 'Statistik',
  'admin.hero.statN': 'Statistik {{n}}',
  'admin.hero.value': 'Nilai',
  'admin.hero.label': 'Label',
  'admin.hero.previewNote': 'Perubahan akan terlihat di beranda setelah disimpan. Muat ulang halaman untuk melihat pratinjau.',

  // Idea History
  'history.title': 'Riwayat Ide',
  'history.countLabel': '{{count}} analisis',
  'history.recentLabel': 'Analisis terbaru Anda',
  'history.exportAll': 'Ekspor semua',
  'history.metrics.marketSize': 'Ukuran Pasar',
  'history.metrics.competition': 'Persaingan',
  'history.metrics.startingCapital': 'Modal Awal',
  'history.metrics.timeToMarket': 'Waktu ke Pasar',
  'history.metrics.profitPotential': 'Potensi Keuntungan',
  'history.metrics.scalability': 'Skalabilitas',
  'history.summary.title': 'Ringkasan',
  'history.download': 'Unduh',
  'history.downloadJSON': 'Simpan sebagai JSON',
  'history.downloadTXT': 'Simpan sebagai TXT',
  'history.downloadPDF': 'Simpan sebagai PDF',
  'history.fullAnalysis': 'Analisis Lengkap',
  'history.searchPlaceholder': 'Cari berdasarkan judul atau tag...',
  'history.filterAll': 'Semua penilaian',
  'history.loading': 'Memuat analisis...',
  'history.noResults': 'Tidak ada hasil ditemukan',
  'history.empty': 'Belum ada analisis',
  'history.emptyHint': 'Mulai analisis di Asisten AI',
  'history.delete': 'Hapus',
  'history.cancel': 'Batal',
  'history.deleteModalTitle': 'Hapus analisis?',
  'history.deleteModalDesc': '"{{title}}" akan dihapus secara permanen.',
  'history.errorLoading': 'Kesalahan memuat analisis',
  'history.deleteSuccess': 'Analisis berhasil dihapus',
  'history.deleteError': 'Kesalahan menghapus analisis',
  'history.jsonExported': 'JSON diekspor',
  'history.txtExported': 'TXT diekspor',
  'history.allExported': '{{count}} ide diekspor',
  'history.analysisHeader': 'ANALISIS IDE',
  'history.titleLabel': 'Judul',
  'history.ratingLabel': 'Penilaian',
  'history.dateLabel': 'Tanggal',
  'history.creditsLabel': 'Kredit',
  'history.analysisSection': 'Analisis',

  // Overview
  'overview.title': 'Ikhtisar',
  'overview.last24h': '24 jam terakhir',
  'overview.analysesToday': 'Analisis hari ini',
  'overview.totalAnalyses': 'Total analisis',
  'overview.successRate': 'Tingkat keberhasilan',
  'overview.topRatings': 'Penilaian teratas',
  'overview.recentActivity': 'Aktivitas terbaru',
  'overview.viewAll': 'Lihat semua',
  'overview.quickAccess': 'Akses cepat',
  'overview.quick.newAnalysis': 'Mulai analisis baru',
  'overview.quick.newAnalysisDesc': 'Mulai analisis ceruk bertenaga AI baru',
  'overview.quick.myAnalyses': 'Analisis saya',
  'overview.quick.myAnalysesDesc': 'Lihat semua analisis sebelumnya',
  'overview.quick.buyCredits': 'Beli kredit',
  'overview.quick.buyCreditsDesc': 'Kredit lebih banyak untuk lebih banyak analisis',
  'overview.quick.settings': 'Pengaturan',
  'overview.quick.settingsDesc': 'Sesuaikan profil dan preferensi',
  'overview.unlimitedCredits': 'Kredit tidak terbatas tersedia',
  'overview.creditsAvailable': 'kredit tersedia',
  'overview.upgradePlan': 'Tingkatkan paket',
  'overview.buyCredits': 'Beli kredit',
  'overview.creditUsage': 'Penggunaan kredit bulan ini',
  'overview.available': 'tersedia',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': 'Peningkatan',
  'admin.transactions.downgrades': 'Penurunan',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}} sekarang memiliki {{months}} bulan paket {{plan}} gratis',
  'admin.users.blockSuccess': '{{name}} diblokir',
  'admin.users.unblockSuccess': '{{name}} dibuka blokirnya',
  'admin.users.removeFreeSuccess': 'Status gratis {{name}} dihapus',

  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Gratis',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Temukan Fitur Baru',
  'admin.tips.productivityBoost': 'Peningkatan Produktivitas',
  'admin.tips.importantUpdate': 'Pembaruan Penting',
  'admin.tips.tipOfDay': 'Tip of the Day',

  'admin.actions.activate': 'Aktifkan',
  'admin.actions.deactivate': 'Nonaktifkan',
  'admin.websiteEditor.tab.features': 'Fitur',
  'admin.websiteEditor.tab.testimonials': 'Testimoni',
  'admin.websiteEditor.tab.faq': 'FAQ',
  'admin.websiteEditor.tab.cta': 'CTA',
  'admin.websiteEditor.tab.footer': 'Footer',
  'admin.websiteEditor.tab.design': 'Desain',
  'admin.websiteEditor.tab.customcode': 'Kode Kustom',
  'admin.websiteEditor.tab.socials': 'Media Sosial',
  'admin.websiteEditor.tab.importexport': 'Impor/Ekspor',

  // --- AI Settings Editor ---
  'admin.ai.title': 'Pengaturan Asisten AI',
  'admin.ai.subtitle': 'Konfigurasikan perilaku, gaya dan kedalaman analisis',
  'admin.ai.smartWeightingActive': 'Pembobotan Cerdas Aktif',
  'admin.ai.smartWeightingDesc': 'AI secara otomatis menggabungkan semua perspektif dengan pembobotan cerdas. Dengan beberapa preset, yang pertama diberi bobot lebih tinggi (preset utama). Anda juga dapat menyesuaikan pembobotan secara manual.',
  'admin.ai.modelTitle': 'Model AI IdeaVerdict',
  'admin.ai.modelSubtitle': 'Pilih mesin AI untuk semua analisis pengguna',
  'admin.ai.activeModel': 'Model aktif:',
  'admin.ai.activeModelDesc': 'Semua pengguna menerima respons dari model ini.',
  'admin.ai.recommendations': 'Rekomendasi untuk Hasil Optimal',
  'admin.ai.new': 'BARU',
  'admin.ai.recommendationsDesc': 'Kombinasi preset terbukti untuk kualitas analisis terbaik',
  'admin.ai.recommendationsInfo': 'Kombinasi ini telah diuji dan memberikan hasil terbaik. Klik rekomendasi untuk menerapkannya langsung.',
  'admin.ai.active': 'AKTIF',
  'admin.ai.apply': 'Terapkan',
  'admin.ai.avoid': 'Hindari',
  'admin.ai.excellentQuality': 'Kualitas Unggul',
  'admin.ai.goodQuality': 'Kualitas Baik',
  'admin.ai.poorQuality': 'Kualitas Encer - Tidak Direkomendasikan',
  'admin.ai.proTips': 'Tips Pro',
  'admin.ai.tip1Title': '2 preset optimal:',
  'admin.ai.tip1Desc': 'Perspektif jelas tanpa pengenceran',
  'admin.ai.tip2Title': 'Preset utama penting:',
  'admin.ai.tip2Desc': 'Preset pertama memiliki pengaruh terbesar',
  'admin.ai.tip3Title': 'Hindari lawan:',
  'admin.ai.tip3Desc': '"EXTREME" + "Kreatif" = kontradiktif',
  'admin.ai.tip4Title': 'Maksimal 3 preset:',
  'admin.ai.tip4Desc': 'Dengan 4+ preset hasilnya menjadi terlalu umum',
  'admin.ai.warningManyPresets': 'Peringatan: Banyak Preset',
  'admin.ai.warningManyPresetsDesc': 'Anda memiliki {{count}} preset dipilih. Ini dapat mengencerkan hasil.',
  'admin.ai.warningRecommend': 'Direkomendasikan: Maksimal 2-3 preset',
  'admin.ai.forOptimalResults': 'untuk hasil optimal.',
  'admin.ai.presets': 'Preset',
  'admin.ai.multiSelect': '(beberapa pilihan dimungkinkan)',
  'admin.ai.presetsDesc': 'Pilih satu atau lebih preset. Preset pertama adalah preset utama dengan bobot tertinggi.',
  'admin.ai.primaryPreset': 'Preset Utama',
  'admin.ai.weightControl': 'Kontrol Bobot',
  'admin.ai.weightControlDesc': 'Sesuaikan seberapa kuat setiap preset mempengaruhi analisis',
  'admin.ai.manual': 'Manual',
  'admin.ai.automatic': 'Otomatis',
  'admin.ai.autoWeightingActive': 'Pembobotan otomatis aktif:',
  'admin.ai.autoWeightingDesc': 'Pembobotan secara otomatis dioptimalkan berdasarkan jumlah preset.',
  'admin.ai.primary': 'UTAMA',
  'admin.ai.totalWeight': 'Total',
  'admin.ai.shouldBe100': 'harus 100%',
  'admin.ai.normalize': 'Normalisasi',
  'admin.ai.combinedSettings': 'Pengaturan Gabungan',
  'admin.ai.presetsCount': 'preset',
  'admin.ai.strictness': 'Ketegasan',
  'admin.ai.realism': 'Realisme',
  'admin.ai.creativity': 'Kreativitas',
  'admin.ai.detailLevel': 'Tingkat Detail',
  'admin.ai.customInstructions': 'Instruksi Kustom',
  'admin.ai.customInstructionsDesc': 'Instruksi tambahan yang digabungkan dengan preset',
  'admin.ai.customInstructionsPlaceholder': 'misal "Fokus pada pasar DACH", "Selalu gunakan angka konkret", "Bandingkan dengan pesaing yang ada", "Selalu jawab dengan contoh"...',
  'admin.ai.customInstructionsHint': 'Instruksi ini secara otomatis digabungkan dengan preset yang dipilih.',
  'admin.ai.manualFinetuning': 'Penyesuaian Manual',
  'admin.ai.manualFinetuningHint': '(opsional, menimpa nilai preset)',
  'admin.ai.manualFinetuningDesc': 'Sesuaikan nilai gabungan secara manual jika Anda ingin menyempurnakan sesuatu.',
  'admin.ai.tone': 'Nada',
  'admin.ai.mild': 'Lembut',
  'admin.ai.strict': 'Tegas',
  'admin.ai.creative': 'Kreatif',
  'admin.ai.realistic': 'Realistis',
  'admin.ai.conservative': 'Konservatif',
  'admin.ai.compact': 'Ringkas',
  'admin.ai.detailed': 'Terperinci',
  'admin.ai.responseLength': 'Panjang Respons',
  'admin.ai.short': 'Singkat & Padat',
  'admin.ai.medium': 'Sedang',
  'admin.ai.long': 'Terperinci',
  'admin.ai.focusAreas': 'Area Fokus Analisis',
  'admin.ai.autoRating': 'Penilaian Otomatis',
  'admin.ai.autoRatingDesc': 'Setiap analisis secara otomatis menerima penilaian (Baik/Sedang/Buruk)',
  'admin.ai.showSources': 'Tampilkan Sumber',
  'admin.ai.showSourcesDesc': 'Referensi ke sumber data dan data pasar dalam respons',
  'admin.ai.hidePreview': 'Sembunyikan Pratinjau',
  'admin.ai.showPreview': 'Tampilkan Pratinjau',
  'admin.ai.aiBehavior': 'Perilaku AI',
  'admin.ai.length': 'Panjang',
  'admin.ai.liveExample': 'Contoh Langsung',
  'admin.ai.testSettings': 'Uji pengaturan Anda',
  'admin.ai.selectExampleQuestion': 'Pilih contoh pertanyaan:',
  'admin.ai.userAsks': 'Pengguna bertanya:',
  'admin.ai.generating': 'AI menghasilkan respons...',
  'admin.ai.generateExample': 'Hasilkan Contoh Respons',
  'admin.ai.aiResponds': 'Asisten AI merespons:',
  'admin.ai.generateHint': 'Klik "Hasilkan Contoh Respons" untuk melihat bagaimana AI merespons dengan pengaturan Anda.',
  'admin.ai.reset': 'Atur Ulang',
  'admin.ai.saved': 'Tersimpan!',
  'admin.ai.saveSettings': 'Simpan Pengaturan',

  // --- Table headers ---
  'admin.coupons.code': 'Kode',
  'admin.coupons.credits': 'Kredit',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': 'Analisis seimbang dengan kualitas tinggi. Pilihan terbaik untuk sebagian besar penilaian ceruk dan validasi ide.',
  'admin.ai.model.preciseAnalyses': 'Analisis Presisi',
  'admin.ai.model.bestBalance': 'Keseimbangan Terbaik',
  'admin.ai.model.recommended': 'Direkomendasikan',
  'admin.ai.model.fastDesc': 'Respons sangat cepat untuk pemeriksaan ceruk cepat, brainstorming dan penilaian awal. Ideal saat kecepatan penting.',
  'admin.ai.model.fast': 'CEPAT',
  'admin.ai.model.fastestResponses': 'Respons Tercepat',
  'admin.ai.model.thinkingDesc': 'Analisis mendalam dengan pemikiran logis tingkat lanjut. Untuk analisis pasar kompleks, penilaian kritis dan perencanaan strategis.',
  'admin.ai.model.deepestAnalysis': 'Analisis Terdalam',
  'admin.ai.model.logicalThinking': 'Pemikiran Logis',
  'admin.ai.model.strategy': 'Strategi',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': 'Analisis Ketat',
  'admin.ai.preset.strict.desc': 'Kritis, berbasis fakta, tanpa pemanis. Mengekspos kelemahan tanpa ampun.',
  'admin.ai.preset.extreme.name': 'Analisis EKSTREM',
  'admin.ai.preset.extreme.desc': 'Ketegasan maksimum, kritik kejam, fokus skenario terburuk. Hanya untuk pemeriksaan realita yang keras.',
  'admin.ai.preset.professional.name': 'Profesional',
  'admin.ai.preset.professional.desc': 'Objektif, terstruktur, seimbang. Seperti konsultan bisnis berpengalaman.',
  'admin.ai.preset.realistic.name': 'Realistis',
  'admin.ai.preset.realistic.desc': 'Jujur dan praktis. Fokus pada implementasi yang layak dan data pasar nyata.',
  'admin.ai.preset.creative.name': 'Kreatif & Memotivasi',
  'admin.ai.preset.creative.desc': 'Inspiratif, kaya ide, positif. Menemukan peluang dan jalur tidak konvensional.',
  'admin.ai.preset.balanced.name': 'Seimbang',
  'admin.ai.preset.balanced.desc': 'Campuran kritik dan motivasi yang baik. Mode default.',
  'admin.ai.preset.investor.name': 'Perspektif Investor',
  'admin.ai.preset.investor.desc': 'Seperti Kapitalis Ventura. Fokus pada skala, ROI dan strategi keluar.',
  'admin.ai.preset.startup-coach.name': 'Pelatih Startup',
  'admin.ai.preset.startup-coach.desc': 'Mentor praktis untuk pendiri. Fokus pada implementasi cepat dan MVP.',
  'admin.ai.preset.market-researcher.name': 'Peneliti Pasar',
  'admin.ai.preset.market-researcher.desc': 'Berbasis data dan analitis. Analisis pasar dan persaingan mendalam.',
  'admin.ai.preset.risk-analyst.name': 'Analis Risiko',
  'admin.ai.preset.risk-analyst.desc': 'Fokus pada risiko dan skenario terburuk. Untuk perencanaan realistis.',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': 'Analisis Pasar',
  'admin.ai.focus.wettbewerb': 'Persaingan',
  'admin.ai.focus.monetarisierung': 'Monetisasi',
  'admin.ai.focus.risiken': 'Risiko',
  'admin.ai.focus.finanzen': 'Keuangan',
  'admin.ai.focus.skalierung': 'Skala',
  'admin.ai.focus.innovation': 'Inovasi',
  'admin.ai.focus.trends': 'Tren',
  'admin.ai.focus.differenzierung': 'Diferensiasi',
  'admin.ai.focus.umsetzung': 'Implementasi',
  'admin.ai.focus.zielgruppe': 'Target Audiens',
  'admin.ai.focus.marketing': 'Pemasaran',

  // --- Tone Options ---
  'admin.ai.tone.direkt': 'Langsung & Kasar',
  'admin.ai.tone.professionell': 'Profesional & Objektif',
  'admin.ai.tone.ehrlich': 'Jujur & Praktis',
  'admin.ai.tone.motivierend': 'Memotivasi & Positif',
  'admin.ai.tone.freundlich': 'Ramah & Mendukung',
  'admin.ai.tone.akademisch': 'Akademis & Analitis',

  // --- Example Questions ---
  'admin.ai.question.niche': 'Ceruk menguntungkan mana yang Anda rekomendasikan?',
  'admin.ai.question.evaluate': 'Nilai ide saya: Aplikasi untuk pemilik anjing',
  'admin.ai.question.trends': 'Tren mana yang saat ini berpotensi?',
  'admin.ai.question.sharpen': 'Bagaimana cara mempertajam ceruk saya?',

  'admin.ai.rec.bestCombination.title': '🏆 Kombinasi Terbaik (2 Preset)',
  'admin.ai.rec.bestCombination.desc': 'Kritis namun konstruktif, dengan langkah tindakan konkret',
  'admin.ai.rec.bestCombination.useCase': 'Direkomendasikan untuk sebagian besar analisis',

  'admin.ai.rec.balancedThree.title': '⚖️ Seimbang (3 Preset)',
  'admin.ai.rec.balancedThree.desc': 'Profesional, realistis dan ramah-investor',
  'admin.ai.rec.balancedThree.useCase': 'Untuk analisis bisnis komprehensif',

  'admin.ai.rec.creativeDriven.title': '💡 Kreatif & Memotivasi (2 Preset)',
  'admin.ai.rec.creativeDriven.desc': 'Inspiratif dengan tips implementasi praktis',
  'admin.ai.rec.creativeDriven.useCase': 'Untuk ide dan brainstorming',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'Buka menu',
  'header.home': 'Beranda',
  'header.notifications': 'Notifikasi',
  'header.settings': 'Pengaturan',
  'header.profile': 'Profil',
  'sidebar.collapse': 'Ciutkan bilah sisi',
  'sidebar.expand': 'Bentangkan bilah sisi',
  'sidebar.close': 'Tutup menu',
  'sidebar.plan': 'Paket',
  'sidebar.backToWebsite': 'Kembali ke situs',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'Selamat datang kembali',
  'overview.greetingSub': 'Inilah yang terjadi di meja putusanmu.',
  'overview.heroCta': 'Putusan baru',
  'overview.currentPlan': 'Paket saat ini',
  'overview.creditsLabel': 'kredit',
  'overview.usedThisCycle': 'Digunakan siklus ini',
  'overview.resetsOn': 'Reset pada',
  'overview.unlimitedTitle': 'Tanpa batas',
  'overview.builderPerk': 'Kamu punya akses Builder penuh — tanpa batas.',
  'overview.runOne': 'Jalankan putusan',
  'overview.lastVerdicts': '5 putusan terakhirmu',
  'overview.noActivity': 'Belum ada putusan — mulai analisis pertamamu',
  'overview.tipTitle': 'Tip',
  'overview.tipBody': 'Jalankan ide melalui dua bahasa — jika putusan melunak di salah satunya, asumsimu lokal, bukan universal.',
  'onboard.skip': "Lewati",
  'onboard.cta.next': "Lanjut",
  'onboard.cta.start': "Mulai",
  'onboard.s1.title': "Selamat datang di IdeaVerdict",
  'onboard.s1.body': "Putusan AI atas ide bisnismu — sebelum kamu membangunnya.",
  'onboard.s2.title': "Putusan jujur tanpa kompromi",
  'onboard.s2.body': "Tanpa hype, tanpa pujian palsu. Data pasar nyata, pesaing nyata, risiko nyata.",
  'onboard.s3.title': "Builder Report dalam bentuk PDF",
  'onboard.s3.body': "Hasilkan laporan 25-75 halaman lengkap dengan arsitektur, keuangan, dan strategi go-to-market.",
  'onboard.s4.title': "Siap kapan pun kamu siap",
  'onboard.s4.body': "Daftar dan dapatkan putusan pertamamu dalam kurang dari satu menit.",
  'builderReport.title': "Membangun Builder Report-mu",
  'builderReport.subtitle': "Analisis komprehensif + briefing developer — terunduh sebagai PDF saat siap.",
  'builderReport.idea': "Ide-mu",
  'builderReport.ideaPlaceholder': "Jelaskan ide bisnismu (atau biarkan kosong untuk memakai ide terakhir yang dibahas)…",
  'builderReport.cta': "Hasilkan Laporan",
  'builderReport.credits': "kredit",
  'builderReport.deductedNow': "Dipotong saat berhasil",
  'builderReport.dontClose': "Mohon jangan tutup jendela ini — pembuatan bisa memakan 30-90 detik.",
  'builderReport.done': "PDF terunduh — cek folder unduhanmu.",
  'builderReport.failed': "Pembuatan gagal",
  'builderReport.close': "Tutup",
  'builderReport.cancel': "Batal",
  'builderReport.running': "Membuat…",
  'builderReport.retry': "Coba lagi",
  'builderReport.unknownError': "Pembuatan gagal. Kreditmu seharusnya dikembalikan.",
  'builderReport.signInRequired': "Kamu harus masuk untuk membuat laporan.",
  'builderReport.ideaRequired': "Mohon jelaskan idemu agar AI punya sesuatu untuk dianalisis.",
  'builderReport.fromChat': "Dari percakapanmu saat ini",
  'builderReport.noIdeaDetected': "Memakai ide yang sedang kita bahas.",
  'builderReport.contextHint': "AI akan memakai semuanya dari chat ini — tidak ada ide baru yang akan dibuat.",
  'builderReport.step.core': "Menghasilkan analisis inti",
  'builderReport.step.market': "Menambahkan analisis pasar yang diperluas",
  'builderReport.step.tech': "Menambahkan arsitektur teknis",
  'builderReport.step.financials': "Menambahkan model keuangan",
  'builderReport.step.compet': "Menambahkan competitive intelligence",
  'builderReport.step.gtm': "Menambahkan strategi go-to-market",
  'builderReport.step.deepdive': "Menambahkan deep-dive industri",
  'builderReport.step.pdf': "Mengompilasi PDF…",
  'briefing.title': "Membangun Developer Briefing-mu",
  'briefing.subtitle': "Briefing teknis 11 bagian — terunduh sebagai PDF saat siap.",
  'briefing.ideaPlaceholder': "Jelaskan ide bisnismu (atau biarkan kosong untuk memakai ide terakhir yang dibahas)…",
  'briefing.cta': "Hasilkan Briefing",
  'briefing.step.core': "Menghasilkan briefing developer",
  'briefing.step.pdf': "Mengompilasi PDF…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Lebih banyak kredit + laporan 50 halaman",
  'pricing.gold.credits': "12.500 Kredit per bulan",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Tier tertinggi + laporan 75 halaman",
  'pricing.platinum.credits': "15.000 Kredit per bulan",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "id" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "Hanya tersisa {{count}} Kredit!",
  'trial.upgradeNow': "Upgrade sekarang",
  'trial.upgradeNowArrow': "Upgrade sekarang →",
  'trial.creditsExhausted': "Kredit habis",
  'trial.upgradeForUnlimited': "Upgrade untuk penggunaan tanpa batas",
  'trial.noCreditsPlaceholder': "Kredit habis…",
  'hero.badgeHonest': "AI jujur dan tidak bias",
  'hero.badge60sec': "Putusan dalam 60 detik",
  'hero.badge20Lang': "20+ bahasa",
  'hero.widget.label': "Idea Verdict",
  'hero.widget.passed': "LULUS",
  'hero.widget.demoIdea': "Tutor AI untuk mahasiswa kedokteran",
  'hero.widget.market': "Pasar",
  'hero.widget.demand': "Permintaan",
  'hero.widget.competition': "Persaingan",
  'hero.widget.verdictReady': "Putusan siap · 47 detik",
  'hero.widget.riskFlagged': "Risiko ditandai",
  'hero.widget.crowdedMarket': "Pasar padat · 4 pemain mapan",
  'hero.widget.suggestedPivot': "Pivot yang disarankan",
  'hero.widget.nicheBySpecialty': "Niche berdasarkan spesialisasi",
  'hero.widget.feasibilityGain': "+38% kelayakan",
  'hero.widget.analysisDone': "Analisis selesai",
  'hero.widget.metrics56': "5 dari 6 metrik",
  'hero.stats.verdictSpeed': "Kecepatan putusan",
  'cta.badge': "Putusan dalam 60 detik",
  'cta.subtitleEnd': "tanpa menebak-nebak.",
  'cta.signinPrompt': "Sudah punya akun? Masuk",
  'cta.trustTrial': "Uji coba gratis 7 hari",
  'cta.trustNoCard': "Tanpa kartu kredit",
  'cta.trustCancel': "Batal kapan saja",
  'footer.themeLabel': "Tema:",
  'footer.lightMode': "Mode Terang",
  'footer.darkMode': "Mode Gelap",
  'footer.sectionProduct': "Produk",
  'footer.sectionLegal': "Legal",
  'nav.switchLight': "Ganti ke Mode Terang",
  'nav.switchDark': "Ganti ke Mode Gelap",
  'features.badge': "Mengapa IdeaVerdict",
  'features.mainFeatureLabel': "Headline",
  'chatError.planRestriction': "Fitur ini memerlukan paket yang lebih tinggi.",
  'chatError.creditDeduction': "Pemrosesan pembayaran gagal. Silakan coba lagi.",
  'chatError.aiService': "Layanan AI sementara tidak tersedia. Kredit Anda tidak dipotong. Silakan coba lagi.",
  'chatError.parseError': "Format respons tidak terduga diterima. Silakan coba lagi.",
  'chatError.sessionExpired': "Sesi Anda telah berakhir. Silakan masuk lagi.",
  'chatError.timeout': "Permintaan terlalu lama. Silakan coba lagi.",
  'chatError.generic': "Gagal mendapatkan respons. Silakan coba lagi.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "id" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "Hanya tersisa {{count}} Kredit!",
  'trial.outOfCredits': "Kredit habis",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "Pasar padat · 4 pemain mapan",
  'hero.widget.nicheBySpec': "Niche berdasarkan spesialisasi",
  'hero.widget.feasibilityUp': "+38% kelayakan",
  'hero.widget.fiveOfSix': "5 dari 6 metrik",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "Builder Report 25 halaman",
  'pricing.gold.report': "Builder Report 50 halaman",
  'pricing.platinum.report': "Builder Report 75 halaman",
  'auth.bestValue': "Nilai Terbaik",
  'auth.elite': "Elite",
  'builderReport.friendlyError': "Kami tidak dapat menyelesaikan laporanmu kali ini. Kreditmu tidak dipotong — silakan coba lagi sebentar lagi.",
  'builderReport.persistHint': "Jika masalah ini terus terjadi, hubungi support@ideaverdict.ai.",
};
